var REQUEST_CONSTANTS = {
  RPC: 'rpc',
  DOWNLOAD: 'download',
  UPLOAD: 'upload'
};

module.exports = REQUEST_CONSTANTS;



//////////////////
// WEBPACK FOOTER
// ./~/dropbox/src/request-constants.js
// module id = 497
// module chunks = 0